import { Button } from '@/shared/components'

type AuthErrorProps = {
  error?: { message?: string } | null
  onRetry: () => void
}

export const AuthError = ({ error, onRetry }: AuthErrorProps) => (
  <div className="flex w-full flex-col items-center gap-3 text-center">
    <p className="text-sm text-red-600" role="alert">
      {error?.message ?? 'Sign-in failed. Please try again.'}
    </p>
    <Button
      type="button"
      variant='light'
      size='sm'
      onClick={() => void onRetry()}
    >
      Try again
    </Button>
  </div>
)
